// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.spotlight.RentalManagerUserPropertySpotlightWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertySpotlightWebApiHandler_excludeListings,
  RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig,
  RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_Path,
  RentalManagerUserPropertySpotlightWebApiHandler_list,
  RentalManagerUserPropertySpotlightWebApiHandler_list_Path,
  RentalManagerUserPropertySpotlightWebApiHandler_overview,
  RentalManagerUserPropertySpotlightWebApiHandler_overview_Path,
  RentalManagerUserPropertySpotlightWebApiHandler_pinListings,
  RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode,
  RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode,
  RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings,
  RentalManagerUserPropertySpotlightWebApiHandler_unpinListings,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  BulkListingSpotlightRequestDto,
  CustomerListingSpotlightOptimizationConfigDto,
  GetSpotlightedListingsResponseDto,
  GetUserPropertySpotlightOverviewResponseDto,
  ListingSpotlightUpdateResultDto,
  SetOptimizationModeRequestDto,
  SetSmartConfigModeRequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Args {
  postData: BulkListingSpotlightRequestDto;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Options = UseMutationOptions<
  Array<ListingSpotlightUpdateResultDto>,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Args
>;

/**
 * Exclude listing spotlight for listings
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_excludeListings = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_excludeListings(args.postData, httpClient),
  });
};

export type RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_Options = UseQueryOptions<
  CustomerListingSpotlightOptimizationConfigDto,
  unknown,
  CustomerListingSpotlightOptimizationConfigDto,
  readonly [string]
>;

const RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_GetKey = () =>
  [RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_Path] as const;

export const RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_GetKey(),
    queryFn: () => RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get optimization config for spotlight
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig.getKey =
  RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_GetKey;

export type RentalManagerUserPropertySpotlightWebApiHandler_list_Options = UseQueryOptions<
  GetSpotlightedListingsResponseDto,
  unknown,
  GetSpotlightedListingsResponseDto,
  readonly [string]
>;

const RentalManagerUserPropertySpotlightWebApiHandler_list_GetKey = () =>
  [RentalManagerUserPropertySpotlightWebApiHandler_list_Path] as const;

export const RentalManagerUserPropertySpotlightWebApiHandler_list_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySpotlightWebApiHandler_list_GetKey(),
    queryFn: () => RentalManagerUserPropertySpotlightWebApiHandler_list(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get listings with spotlight promotion
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_list = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_list_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserPropertySpotlightWebApiHandler_list_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySpotlightWebApiHandler_list.getKey =
  RentalManagerUserPropertySpotlightWebApiHandler_list_GetKey;

export type RentalManagerUserPropertySpotlightWebApiHandler_overview_Options = UseQueryOptions<
  GetUserPropertySpotlightOverviewResponseDto,
  unknown,
  GetUserPropertySpotlightOverviewResponseDto,
  readonly [string]
>;

const RentalManagerUserPropertySpotlightWebApiHandler_overview_GetKey = () =>
  [RentalManagerUserPropertySpotlightWebApiHandler_overview_Path] as const;

export const RentalManagerUserPropertySpotlightWebApiHandler_overview_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySpotlightWebApiHandler_overview_GetKey(),
    queryFn: () => RentalManagerUserPropertySpotlightWebApiHandler_overview(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get spotlight overview for user properties
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_overview = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_overview_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserPropertySpotlightWebApiHandler_overview_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySpotlightWebApiHandler_overview.getKey =
  RentalManagerUserPropertySpotlightWebApiHandler_overview_GetKey;

export interface RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Args {
  postData: BulkListingSpotlightRequestDto;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Options = UseMutationOptions<
  Array<ListingSpotlightUpdateResultDto>,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Args
>;

/**
 * Pin listing spotlight for listings
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_pinListings = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_pinListings(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Args {
  postData: SetOptimizationModeRequestDto;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Args
>;

/**
 * Set optimization mode for spotlight
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode_Args {
  postData: SetSmartConfigModeRequestDto;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode_Args
>;

/**
 * Set smart config mode for spotlight
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Args {
  postData: BulkListingSpotlightRequestDto;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Options = UseMutationOptions<
  Array<ListingSpotlightUpdateResultDto>,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Args
>;

/**
 * Unexclude listing spotlight for listings
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Args {
  postData: BulkListingSpotlightRequestDto;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Options = UseMutationOptions<
  Array<ListingSpotlightUpdateResultDto>,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Args
>;

/**
 * Unpin listing spotlight for listings
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_unpinListings = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_unpinListings(args.postData, httpClient),
  });
};
